import copyEntity from "./copyEntity";

export default copyEntity;
